import {
  DayReplacementsConnectorApollo,
  ReplaceDayConnectorApollo,
  createDateObject,
  useTimestamp,
} from '@front-activerse/common-components';
import DayPlanChangeDayContainer from './components/DayPlanChangeDayContainer';
import DayReplacement from './components/DayPlanDayReplacement';
import { useParams } from 'react-router-dom';

const DayReplacementPage = () => {
  const { date } = useParams();
  const { timestamp2 } = useTimestamp();

  const renderDayReplacements = (replacements, search, replaceDay) =>
    replacements.map((replacement) => (
      <DayReplacement
        key={replacement.dietSetId}
        dayReplacement={replacement}
        search={search}
        replaceDay={replaceDay}
        date={date}
      />
    ));

  return (
    <DayReplacementsConnectorApollo key={timestamp2 + date} date={createDateObject(date)}>
      {({ loadDayPlanDayReplacements }) => (
        <ReplaceDayConnectorApollo key={timestamp2 + date} date={createDateObject(date)}>
          {({ replaceDay }) => (
            <DayPlanChangeDayContainer
              key={timestamp2 + date}
              replaceDay={replaceDay}
              loadDayPlanDayReplacements={loadDayPlanDayReplacements}
              renderOriginalDay={(original, search, replaceDay) =>
                renderDayReplacements([original], search, replaceDay)
              }
            >
              {(replacements, search, replaceDay) =>
                renderDayReplacements(replacements, search, replaceDay)
              }
            </DayPlanChangeDayContainer>
          )}
        </ReplaceDayConnectorApollo>
      )}
    </DayReplacementsConnectorApollo>
  );
};

export default DayReplacementPage;
